// extracted by mini-css-extract-plugin
export default {"novaTarefa":"formulario_novaTarefa__CN65R","inputContainer":"formulario_inputContainer__JbAHd"};